export function getHttpRequestStatusOk({ status }) {
  return status > 100 && status < 300
}
